import React, { FC, MouseEvent } from 'react';
import { Core } from '..';
import { DesignSystem } from '@everfi/design-system';
import { i18n } from '../i18n/translate';
interface Router {
  goBack?: () => void;
}

interface BackButtonProps {
  action: boolean | ((e: MouseEvent<HTMLAnchorElement>) => void);
  router?: Router;
}

/**
 * Renders a back button.
 * If action === true, it uses router to go back.
 * Else it calls the action function.
 */
export const BackButton: FC<BackButtonProps> = ({ action, router }) => {
  const onClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (action === true) {
      if (router?.goBack) {
        router.goBack();
      } else {
        throw new Error('must pass router as a prop in order to use default back action');
      }
    } else if (typeof action === 'function') {
      action(e);
    }
  };

  return (
    <Core.IconButton
      ariaLabel={i18n.t('Back')}
      variant={'link'}
      onClick={onClick}
      data-back-arrow={true}
      // size={'compact'}
      colorScheme={'brand'}
      tooltip={{
        content: i18n.t('Back'),
      }}
      icon={{ iconName: 'fa-arrow-left' }}
    />
  );
};
